import { configVars } from 'src/helpers';

export const NAME = 'resources';

export const URL_FILE_P2PDF = `${configVars.frontend_url}/assets/documents/Print_To_Pdf_Instructions.pdf`;
